import RoutesMap from "route_control/RouteControl"
import { WishlistList, CartList, OrderList, OrderDetails, ContactUsList } from "pages/sales"

const SalesRoute = () => {
    return [
        {
            path: RoutesMap.WISHLIST_LIST.path,
            element: <WishlistList />
        },
        {
            path: RoutesMap.CART_LIST.path,
            element: <CartList />
        },
        {
            path: RoutesMap.ORDER_LIST.path,
            element: <OrderList />
        },
        {
            path: RoutesMap.ORDER_DETAILS.path,
            element: <OrderDetails />
        },
        {
            path: RoutesMap.CONTACT_US_LIST.path,
            element: <ContactUsList />
        },
    ]
}

export default SalesRoute;